var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrgevenlogo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 106.4",
    style: {
      enableBackground: "new 0 0 500 106.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1204A5;}\n\t.st1{fill:#FF6300;}\n\t.st2{fill:#5786FD;}\n\t.st3{fill:#00B6D5;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M170.4,32.5L170.4,32.5c-13.8,0-25,11.2-25,25c0,13.8,11.2,25,25,25h0c13.8,0,25-11.2,25-25 C195.4,43.6,184.2,32.5,170.4,32.5 M180.7,57.4c0,5.7-4.6,10.3-10.3,10.3h0c-5.7,0-10.3-4.6-10.3-10.3c0-5.7,4.6-10.3,10.3-10.3h0 C176.1,47.1,180.7,51.7,180.7,57.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M257.9,32.5L257.9,32.5c-13.2,0-23.9,10.7-23.9,23.9c0,13.2,10.7,23.9,23.9,23.9c13.2,0,23.9-10.7,23.9-23.9 C281.8,43.2,271.1,32.5,257.9,32.5 M267.8,56.4c0,5.5-4.4,9.9-9.9,9.9c-5.5,0-9.9-4.4-9.9-9.9c0-5.5,4.4-9.9,9.9-9.9 C263.3,46.5,267.8,50.9,267.8,56.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M267.8,82.5c0,5.4-4.4,9.9-9.9,9.9c-5.5,0-9.9-4.4-9.9-9.9h-14.1c0,13.2,10.7,23.9,23.9,23.9 c13.2,0,23.9-10.7,23.9-23.9H267.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M300.7,79.2c-3.7-2.1-6.6-5.1-8.7-8.9c-2.1-3.8-3.1-8.1-3.1-12.9c0-4.8,1-9.1,3.1-12.9 c2.1-3.8,5.1-6.7,8.9-8.9c3.8-2.1,8.2-3.2,13-3.2c4.4,0,8.4,1.1,12,3.3c3.5,2.2,6.4,5.5,8.5,9.8c2.1,4.3,3.2,9.4,3.2,15.3h-36 l1.3-1.4c0,3.4,1.1,6.1,3.3,8.2c2.2,2.1,5,3.1,8.2,3.1c2.4,0,4.4-0.5,6.1-1.6c1.7-1,2.9-2.5,3.8-4.2l12.1,4.4c-2,4.3-5,7.5-8.9,9.7 c-3.9,2.2-8.5,3.3-13.9,3.3C308.7,82.4,304.5,81.3,300.7,79.2 M302.1,51.3h22.2l-1.1,1.5c0-3.2-1-5.5-2.9-7.1 c-1.9-1.6-4.2-2.3-6.7-2.3c-1.6,0-3.1,0.3-4.7,1c-1.5,0.7-2.8,1.7-3.9,3.1c-1,1.4-1.6,3.2-1.6,5.4L302.1,51.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M407.5,79.2c-3.7-2.1-6.6-5.1-8.7-8.9c-2.1-3.8-3.1-8.1-3.1-12.9c0-4.8,1-9.1,3.1-12.9 c2.1-3.8,5.1-6.7,8.9-8.9c3.8-2.1,8.2-3.2,13-3.2c4.4,0,8.4,1.1,12,3.3c3.5,2.2,6.4,5.5,8.5,9.8c2.1,4.3,3.2,9.4,3.2,15.3h-36 l1.3-1.4c0,3.4,1.1,6.1,3.3,8.2c2.2,2.1,5,3.1,8.2,3.1c2.4,0,4.4-0.5,6.1-1.6c1.7-1,2.9-2.5,3.8-4.2l12.1,4.4c-2,4.3-5,7.5-8.9,9.7 c-3.9,2.2-8.5,3.3-13.9,3.3C415.5,82.4,411.2,81.3,407.5,79.2 M408.9,51.3h22.2l-1.1,1.5c0-3.2-1-5.5-2.9-7.1 c-1.9-1.6-4.2-2.3-6.7-2.3c-1.6,0-3.1,0.3-4.7,1c-1.5,0.7-2.8,1.7-3.9,3.1c-1,1.4-1.6,3.2-1.6,5.4L408.9,51.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M337.6,32.5h14.7l18.6,49.9H358L337.6,32.5z M377.8,32.5h14.7l-20.4,49.9h-13L377.8,32.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M200.2,59.8v20.5h13.2V62.2c0.6-14.1,11.7-15.5,16.4-15.5V33.9h-3.7C211.8,33.9,200.2,45.5,200.2,59.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M495.4,38.3c-0.3-0.4-0.6-0.8-0.9-1.2c-3.5-4-8.8-6-14-6.8c-4.4-0.6-9-0.4-13.2,1.2c-4.2,1.5-8,4.3-10.4,8.1 c-3.5,5.5-3.6,12.2-3.6,18.5v25.6h14.2V58.1c0-2,0.2-3.8,0.5-5.3c0.4-1.6,1.1-2.9,2-3.9c1.7-2,4.1-2.9,7.3-2.8 c1.7,0,3.2,0.4,4.4,1.1c0,0,0.1,0,0.1,0.1c0.1,0.1,0.2,0.1,0.3,0.2c0.5,0.3,0.9,0.7,1.3,1.2c0.5,0.6,1,1.4,1.3,2.2 c0.7,1.8,1.1,4.3,1.1,7.4v25.6H500V58.3c0-3.8,0-7.6-0.9-11.3C498.5,43.9,497.3,40.9,495.4,38.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.4,14.9L46.4,14.9c-4.1,0-7.5-3.3-7.5-7.5c0-4.1,3.3-7.5,7.5-7.5c4.1,0,7.5,3.3,7.5,7.5 C53.9,11.6,50.5,14.9,46.4,14.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.5,14.9L7.5,14.9C3.3,14.9,0,11.6,0,7.5C0,3.3,3.3,0,7.5,0c4.1,0,7.5,3.3,7.5,7.5 C14.9,11.6,11.6,14.9,7.5,14.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.9,49.9c13.8,0,24.9-11.2,24.9-25H39.2c0,5.7-4.6,10.3-10.3,10.3V49.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.2,49.9c-13.8,0-24.9-11.2-24.9-25h14.7c0,5.7,4.6,10.3,10.3,10.3V49.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M109.9,25L109.9,25c0-13.8-11.2-25-25-25C71.2,0,60,11.2,60,25c0,13.8,11.2,25,25,25 C98.8,49.9,109.9,38.8,109.9,25 M74.7,25c0-5.7,4.6-10.3,10.3-10.3c5.7,0,10.3,4.6,10.3,10.3c0,5.7-4.6,10.3-10.3,10.3 C79.3,35.3,74.7,30.7,74.7,25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M74.7,105.8c0-5.7,4.6-10.3,10.3-10.3c5.7,0,10.3,4.6,10.3,10.3h14.7c0-13.8-11.2-25-25-25 c-13.8,0-25,11.2-25,25H74.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M95.3,56.1c0,5.7-4.6,10.3-10.3,10.3c-5.7,0-10.3-4.6-10.3-10.3H60c0,13.8,11.2,25,25,25c13.8,0,25-11.2,25-25 H95.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 56.1,
    className: "st3",
    width: 12.3,
    height: 49.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.7,
    y: 77.5,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -52.0827 41.4826)",
    className: "st3",
    width: 49.5,
    height: 12.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.7,
    y: 56,
    className: "st3",
    width: 49.5,
    height: 12.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M74.7,105.8c0-5.7,4.6-10.3,10.3-10.3c5.7,0,10.3,4.6,10.3,10.3h14.7c0-13.8-11.2-25-25-25 c-13.8,0-25,11.2-25,25H74.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M95.3,56.1c0,5.7-4.6,10.3-10.3,10.3c-5.7,0-10.3-4.6-10.3-10.3H60c0,13.8,11.2,25,25,25c13.8,0,25-11.2,25-25 H95.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrgevenlogo1);
export default __webpack_public_path__ + "static/media/Orgeven logo 1.af6eef63dbc247d386fe7631a3575600.svg";
export { ForwardRef as ReactComponent };